export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "subheader": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add New Member"])},
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invite User"])},
        "add_new_member": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add New Member"])},
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Role"])},
        "auto_register_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Auto register containers"])},
        "error_warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cannot save: see error messages above"])}
      },
      "fr": {
        "subheader": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter un nouveau membre"])},
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inviter un utilisateur"])},
        "add_new_member": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter un nouveau membre"])},
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Courriel"])},
        "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rôle"])},
        "auto_register_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["l'auto-enregistrement des conteneurs"])},
        "error_warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossible de sauver: voyez les messages d'erreur ci-dessus"])}
      }
    }
  })
}